// extracted by mini-css-extract-plugin
export default {"root":"MenuPager_root__ndQAC","menu":"MenuPager_menu__+VLfl","back_menu":"MenuPager_back_menu__+EBWF","link":"MenuPager_link__dCVx6","forward":"MenuPager_forward__Q4zWn"};